import { darken, styled } from '@mui/material/styles'
import { Button } from '@mui/material'
import { createWithLoadingButton } from '$common/buttons/with-loading-button'

// TODO it should be clear for color of button on hover
const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.error500,
  color: '#ffffff',
  '&:hover': {
    backgroundColor: darken(theme.palette.error500, 0.1),
    boxShadow: 'none',
  },
  boxShadow: 'none',
  '&.Mui-disabled': {
    backgroundColor: `${theme.palette.error300} !important`,
  },
}))

export const ErrorButton = createWithLoadingButton(StyledButton)
